import { Link } from "react-router-dom";

const socials = [
  { icon: "ri-wechat-line", label: "微信" },
  { icon: "ri-weibo-line", label: "微博" },
  { icon: "ri-bilibili-line", label: "哔哩哔哩" },
  { icon: "ri-youtube-line", label: "YouTube" },
];

export default function Footer() {
  return (
    <footer className="w-full bg-primary-950 text-primary-100 mt-16">
      <div className="w-full px-4 md:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 rounded-md bg-primary-500 text-background-50 flex items-center justify-center font-label font-bold text-lg">
                51
              </span>
              <span className="font-heading font-semibold text-lg text-background-50">51每日大赛</span>
            </div>
            <p className="text-sm text-primary-200/90 leading-relaxed">
              51每日大赛，提供全面的每日赛事信息，覆盖各类竞技项目，实时发布比赛时间、赛程安排和最新比赛结果。
            </p>
          </div>

          <div>
            <h3 className="font-heading text-base text-background-50 mb-4">快速导航</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/events" className="text-primary-200/90 hover:text-background-50 transition-colors">赛事分类</Link></li>
              <li><Link to="/schedule" className="text-primary-200/90 hover:text-background-50 transition-colors">赛程安排</Link></li>
              <li><Link to="/news" className="text-primary-200/90 hover:text-background-50 transition-colors">新闻资讯</Link></li>
              <li><Link to="/about" className="text-primary-200/90 hover:text-background-50 transition-colors">关于我们</Link></li>
              <li><Link to="/contact" className="text-primary-200/90 hover:text-background-50 transition-colors">联系我们</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base text-background-50 mb-4">友情链接</h3>
            <ul className="space-y-2 text-sm">
              <li><a href="https://shxiazhan.cn" target="_blank" rel="noreferrer" className="text-primary-200/90 hover:text-background-50 transition-colors">奥林匹克官网</a></li>
              <li><a href="https://www.fifa.com" target="_blank" rel="noreferrer" className="text-primary-200/90 hover:text-background-50 transition-colors">国际足联</a></li>
              <li><a href="https://www.nba.com" target="_blank" rel="noreferrer" className="text-primary-200/90 hover:text-background-50 transition-colors">NBA 官方</a></li>
              <li><a href="https://www.wtt.com" target="_blank" rel="noreferrer" className="text-primary-200/90 hover:text-background-50 transition-colors">WTT 世界乒联</a></li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base text-background-50 mb-4">关注我们</h3>
            <div className="flex items-center gap-3">
              {socials.map((s) => (
                <span
                  key={s.label}
                  title={s.label}
                  className="w-10 h-10 rounded-md bg-primary-900 flex items-center justify-center text-primary-100 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer"
                >
                  <i className={`${s.icon} text-lg`} />
                </span>
              ))}
            </div>
            <p className="text-sm text-primary-200/90 mt-4">合作邮箱：hello@51dailyarena.com</p>
          </div>
        </div>

        <div className="border-t border-primary-900 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-primary-200/80">
          <p>© 2026 51每日大赛 · 本站赛事与新闻信息均为演示内容</p>
          <p>本站数据仅用于展示，不构成任何赛事投注依据</p>
        </div>
      </div>
    </footer>
  );
}